import { george, observer, pr, ui } from "aaa";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { safeWindowOpen } from "util/helpers";
import { AppStoreRedirectStoreDeprecated } from "./AppStoreRedirectStoreDeprecated";

const FOOTER_HEIGHT = 64;

const LandingPageHeader = () => (
    <pr.HeaderBackground
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 235,
            backgroundColor: "#2870ED"
        }}
    >
        <img
            src={require("../../assets/illustration_george_app.svg")}
            alt=""
        />
    </pr.HeaderBackground>
);

const LandingPageFooter = () => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            bottom: 0,
            width: "100%",
            height: FOOTER_HEIGHT,
            backgroundColor: "#2870ED",
        }}
    >
        <img
            src={require("../../assets/george_app_footer_logo.svg")}
            alt=""
        />
    </div>
);

export const AppStoreRedirectSiteDeprecated = observer(({ store }: { store: AppStoreRedirectStoreDeprecated }) => {
    const isUnknownOs = !externalInterfaceStore.isAndroid && !externalInterfaceStore.isIos && !externalInterfaceStore.isHuawei;

    let redirectUrl: string | undefined;

    if (externalInterfaceStore.isIos) {
        redirectUrl = store.iosStoreUrl;
    } else if (externalInterfaceStore.isAndroid) {
        redirectUrl = store.androidStoreUrl;
    } else if (externalInterfaceStore.isHuawei) {
        redirectUrl = store.appGalleryStoreUrl;
    }

    React.useEffect(() => {
        if (redirectUrl) {
            safeWindowOpen(redirectUrl);
        }
    }, [redirectUrl]);

    if (redirectUrl) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.LandingBackground useWebVersion style={{ boxSizing: "border-box", paddingBottom: FOOTER_HEIGHT, position: "relative" }}>
            <LandingPageHeader />
            <div style={{ padding: 24 }}>
                <pr.P_24_TITLE style={{ textAlign: "center", fontWeight: 600 }}>{ui.__("appStoreRedirect.landingPage.title")}</pr.P_24_TITLE>
                <pr.P_16_TITLE style={{ textAlign: "center" }}>{ui.__("appStoreRedirect.landingPage.subTitle")}</pr.P_16_TITLE>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexWrap: "wrap",
                        marginTop: 40,
                        gap: 15
                    }}
                >
                    {(externalInterfaceStore.isAndroid || isUnknownOs) &&
                        <a
                            target="_blank"
                            href={store.androidStoreUrl}
                            role="button"
                            title={ui.__("common.download.playStore")}
                        >
                            <img alt="" style={{ height: 50 }} src={externalInterfaceStore.androidStoreIconUrl} />
                        </a>
                    }
                    {(externalInterfaceStore.isIos || isUnknownOs) &&
                        <a
                            target="_blank"
                            href={store.iosStoreUrl}
                            role="button"
                            title={ui.__("common.download.appStore")}
                        >
                            <img alt="" style={{ height: 50 }} src={externalInterfaceStore.iosStoreIconUrl} />
                        </a>
                    }
                    {(externalInterfaceStore.isHuawei || isUnknownOs) &&
                        <a
                            target="_blank"
                            href={store.appGalleryStoreUrl}
                            role="button"
                            title={ui.__("common.download.appGallery")}
                        >
                            <img alt="" style={{ height: 50 }} src={externalInterfaceStore.appGalleryIconUrl} />
                        </a>
                    }
                </div>
                <pr.P_16_CONTENT style={{ textAlign: "center", marginTop: 40 }}>
                    {ui.__("appStoreRedirect.landingPage.description")}
                </pr.P_16_CONTENT>
            </div>
            <LandingPageFooter />
        </george.LandingBackground>
    );
});


// WEBPACK FOOTER //
// ./src/components/appStoreRedirectDeprecated/AppStoreRedirectSiteDeprecated.tsx